﻿export enum ResourceType {
	Test,
	Video,
	Pdf,
	WordDocument,
	PowerpointDocument,
	ExcelDocument,
	ZipFile,
	Glossary,
	MediaPlusSSO,
	WebContent
}

export enum DeliverableType{
	PracticeTest = 1,
	EBook = 2,
	Course = 3,
	XedCourse = 8
}

export enum LicenseType {
	Site = 1,
	Individual,
	Seat
}

export enum TransactionType {
	SCARecordWay,
	Single = 1,
	Multiple,
	Seat,
	Assignment,
	Classroom,
	Partner
}

export enum ERole {
    SYSADMIN = 1,
    DISTRIBUTOR,
    RESELLER,
    TESTING_CENTER
}